module.exports = "<svg height=\"48\" viewBox=\"0 0 48 48\" width=\"48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.02 42l41.98-18-41.98-18-.02 14 30 4-30 4z\"></path><path d=\"M0 0h48v48h-48z\" fill=\"none\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/reply.svg
// module id = 875
// module chunks = 0